import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { ICategory } from '../model/category/Category';
import { useParams } from 'react-router-dom';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useCategoriesResult {
    isLoaded: boolean;
    categories: ICategory[] | null;
}

export const useCategories = () => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();
    const { projectId, gameVersionId } = useParams<{ projectId: string, gameVersionId: string }>();

    const [result, setResult] = useState<useCategoriesResult>({ isLoaded: false, categories: [] });

    useEffect(() => {
        setResult({ isLoaded: false, categories: [] });

        rootStore.categoryStore.loadCategories()
            .then(() => {
                setResult({
                    isLoaded: true,
                    categories: rootStore.categoryStore.categories
                });

            })
            .catch(e => publishNotification({
                text: `Error loading categories: ${e.message}`,
                canClose: true
            }));

        return () => {
            rootStore.categoryStore.clearCategories();
        };
    }, [rootStore.categoryStore, publishNotification, projectId, gameVersionId]);

    return result;
};
